export const STARLINK_OBSTRUCTION_NO_DATA = 255;
